/* Luteria Fagundes — página de produto: foto ampliada com lupa (zoom no computador e no celular) */
(function () {
  'use strict';
  if (window.LFZoom) return;
  var LFZoom = window.LFZoom = {};
  var mqMob = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
  var reduz = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
  var MAX = 3, ZOOM = 2.5, LARGURA_HD = 3072;

  var svg = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
  var IC = {
    mais: svg('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.4 15.4 20.5 20.5M10.5 7.8v5.4M7.8 10.5h5.4"/>'),
    menos: svg('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.4 15.4 20.5 20.5M7.8 10.5h5.4"/>'),
    fechar: svg('<path d="M6 6l12 12M18 6 6 18"/>'),
    esq: svg('<path d="M14.5 5.5 8 12l6.5 6.5"/>'),
    dir: svg('<path d="M9.5 5.5 16 12l-6.5 6.5"/>')
  };

  function srcHD(im) {
    var url = '', maior = 0;
    (im.getAttribute('srcset') || '').split(',').forEach(function (p) {
      var partes = p.trim().split(/\s+/), w = parseInt(partes[1], 10) || 0;
      if (partes[0] && w >= maior) { maior = w; url = partes[0]; }
    });
    url = url || im.getAttribute('src') || '';
    if (/[?&]width=\d+/.test(url)) url = url.replace(/([?&])width=\d+/, '$1width=' + LARGURA_HD);
    else if (url) url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + LARGURA_HD;
    return url;
  }

  /* ---------------- Visualizador (único na página) ---------------- */
  var LB = null;
  function visualizador() {
    if (LB) return LB;
    var el = document.createElement('div');
    el.className = 'lfp-lb';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Foto ampliada');
    el.innerHTML =
      '<div class="lfp-lb__view" data-v><img class="lfp-lb__img" data-i alt="" draggable="false"></div>' +
      '<div class="lfp-lb__bar">' +
        '<span class="lfp-lb__count" data-c></span>' +
        '<div class="lfp-lb__acts">' +
          '<button type="button" class="lfp-lb__btn lfp-lb__btn--lupa" data-z aria-label="Aumentar zoom">' + IC.mais + '</button>' +
          '<button type="button" class="lfp-lb__btn" data-x aria-label="Fechar">' + IC.fechar + '</button>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="lfp-lb__nav lfp-lb__nav--prev" data-p aria-label="Foto anterior">' + IC.esq + '</button>' +
      '<button type="button" class="lfp-lb__nav lfp-lb__nav--next" data-n aria-label="Próxima foto">' + IC.dir + '</button>' +
      '<p class="lfp-lb__dica" aria-hidden="true"><span class="lfp-lb__dica-d">Clique na foto ou na lupa para ampliar</span><span class="lfp-lb__dica-m">Toque duas vezes ou use dois dedos para ampliar</span></p>';
    document.body.appendChild(el);

    var view = el.querySelector('[data-v]'), img = el.querySelector('[data-i]'), cnt = el.querySelector('[data-c]');
    var bz = el.querySelector('[data-z]'), bx = el.querySelector('[data-x]'), bp = el.querySelector('[data-p]'), bn = el.querySelector('[data-n]');
    var itens = [], idx = 0, s = 1, tx = 0, ty = 0, bw = 0, bh = 0;
    var aberto = false, comHist = false, ultimoFoco = null;

    function aplicar(anim) {
      img.style.transition = anim && !reduz() ? 'transform 280ms cubic-bezier(.2,.7,.2,1)' : 'none';
      img.style.transform = 'translate(-50%,-50%) translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
      var z = s > 1.01;
      if (el.classList.contains('is-zoom') !== z) {
        el.classList.toggle('is-zoom', z);
        bz.innerHTML = z ? IC.menos : IC.mais;
        bz.setAttribute('aria-label', z ? 'Diminuir zoom' : 'Aumentar zoom');
      }
    }
    function limitar() {
      var mx = Math.max(0, (bw * s - view.clientWidth) / 2), my = Math.max(0, (bh * s - view.clientHeight) / 2);
      tx = Math.max(-mx, Math.min(mx, tx));
      ty = Math.max(-my, Math.min(my, ty));
    }
    function zoomEm(ns, px, py, anim) {
      ns = Math.max(1, Math.min(MAX, ns));
      var r = view.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      if (px == null) { px = cx; py = cy; }
      tx = px - cx - (px - cx - tx) * ns / s;
      ty = py - cy - (py - cy - ty) * ns / s;
      s = ns;
      if (s <= 1.001) { s = 1; tx = 0; ty = 0; }
      limitar();
      aplicar(anim);
      if (s > 1) el.classList.add('is-used');
    }
    function alternar(px, py) { if (s > 1.01) zoomEm(1, null, null, true); else zoomEm(ZOOM, px, py, true); }
    function medir() {
      var it = itens[idx]; if (!it) return;
      var mob = mqMob.matches;
      var aw = view.clientWidth - (mob ? 0 : 176), ah = view.clientHeight - (mob ? 136 : 144);
      var ratio = it.w && it.h ? it.w / it.h : 0.8;
      bw = Math.max(50, Math.min(aw, ah * ratio));
      bh = bw / ratio;
      img.style.width = bw + 'px';
      img.style.height = bh + 'px';
    }
    function mostrar(i) {
      var n = itens.length;
      idx = ((i % n) + n) % n;
      var it = itens[idx];
      s = 1; tx = 0; ty = 0;
      medir();
      aplicar(false);
      img.alt = it.alt || '';
      img.src = it.low || it.src;
      if (it.low && it.low !== it.src) {
        var hd = new Image();
        hd.decoding = 'async';
        hd.onload = function () { if (aberto && itens[idx] === it) img.src = it.src; };
        hd.src = it.src;
      }
      cnt.textContent = (idx + 1) + ' / ' + n;
      cnt.hidden = bp.hidden = bn.hidden = n < 2;
      [idx + 1, idx - 1].forEach(function (k) {
        var o = itens[((k % n) + n) % n];
        if (o && !o.pre) { o.pre = new Image(); o.pre.src = o.src; }
      });
    }
    function abrir(lista, i) {
      if (!lista.length) return;
      itens = lista;
      ultimoFoco = document.activeElement;
      aberto = true;
      el.hidden = false;
      document.documentElement.classList.add('lfp-lb-on');
      mostrar(i);
      void el.offsetWidth;
      el.classList.add('is-open');
      try { bx.focus({ preventScroll: true }); } catch (_) { bx.focus(); }
      document.querySelectorAll('video, audio').forEach(function (m) { if (!m.paused) { try { m.pause(); } catch (_) {} } });
      try { history.pushState({ lfpLb: 1 }, ''); comHist = true; } catch (_) { comHist = false; }
    }
    function fechar(peloHistorico) {
      if (!aberto) return;
      if (!peloHistorico && comHist && history.state && history.state.lfpLb) { history.back(); return; }
      aberto = false; comHist = false;
      el.classList.remove('is-open', 'is-zoom', 'is-drag');
      bz.innerHTML = IC.mais;
      bz.setAttribute('aria-label', 'Aumentar zoom');
      document.documentElement.classList.remove('lfp-lb-on');
      el.hidden = true;
      img.removeAttribute('src');
      ptrs = {}; gest = null;
      if (ultimoFoco && ultimoFoco.focus) { try { ultimoFoco.focus({ preventScroll: true }); } catch (_) {} }
    }
    window.addEventListener('popstate', function () { if (aberto) fechar(true); });

    bz.addEventListener('click', function () { alternar(); });
    bx.addEventListener('click', function () { fechar(); });
    bp.addEventListener('click', function () { mostrar(idx - 1); });
    bn.addEventListener('click', function () { mostrar(idx + 1); });

    /* Gestos: arrastar, pinça, toque duplo, clique, deslizar para trocar de foto */
    var ptrs = {}, gest = null, ultToque = 0, ultX = 0, ultY = 0;
    var qtd = function () { return Object.keys(ptrs).length; };
    function pinca() {
      var k = Object.keys(ptrs), a = ptrs[k[0]], b = ptrs[k[1]];
      return { d: Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)), x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
    }
    view.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button > 0) return;
      try { view.setPointerCapture(e.pointerId); } catch (_) {}
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (qtd() === 2) {
        var p = pinca();
        gest = { tipo: 'pinca', d0: p.d, s0: s, x: p.x, y: p.y };
        el.classList.add('is-drag');
      } else if (qtd() === 1) {
        gest = { tipo: 'um', x0: e.clientX, y0: e.clientY, tx0: tx, ty0: ty, moveu: false, mouse: e.pointerType === 'mouse' };
      }
    });
    view.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return;
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (!gest) return;
      if (gest.tipo === 'pinca' && qtd() >= 2) {
        var p = pinca();
        tx += p.x - gest.x; ty += p.y - gest.y;
        gest.x = p.x; gest.y = p.y;
        zoomEm(gest.s0 * p.d / gest.d0, p.x, p.y, false);
      } else if (gest.tipo === 'um') {
        var dx = e.clientX - gest.x0, dy = e.clientY - gest.y0;
        if (!gest.moveu && Math.abs(dx) + Math.abs(dy) > 6) { gest.moveu = true; el.classList.add('is-drag'); }
        if (!gest.moveu) return;
        if (s > 1.01) { tx = gest.tx0 + dx; ty = gest.ty0 + dy; limitar(); aplicar(false); }
        else if (itens.length > 1 && !gest.pos) {
          img.style.transition = 'none';
          img.style.transform = 'translate(-50%,-50%) translate(' + dx + 'px,0)';
        }
      }
    });
    function soltar(e) {
      if (!ptrs[e.pointerId]) return;
      delete ptrs[e.pointerId];
      var g = gest;
      if (qtd() === 1 && g && g.tipo === 'pinca') {
        var k = Object.keys(ptrs)[0];
        gest = { tipo: 'um', x0: ptrs[k].x, y0: ptrs[k].y, tx0: tx, ty0: ty, moveu: true, pos: true };
        return;
      }
      if (qtd() > 0) return;
      gest = null;
      el.classList.remove('is-drag');
      if (!g) return;
      if (g.tipo !== 'um') { if (s < 1.05) zoomEm(1, null, null, true); return; }
      if (e.type === 'pointercancel') { if (s <= 1.01) aplicar(true); return; }
      var dx = e.clientX - g.x0;
      if (g.moveu) {
        if (s <= 1.01 && !g.pos && itens.length > 1) {
          if (Math.abs(dx) > 60) mostrar(idx + (dx < 0 ? 1 : -1));
          else aplicar(true);
        }
        return;
      }
      if (g.mouse) { alternar(e.clientX, e.clientY); return; }
      var agora = Date.now();
      if (agora - ultToque < 320 && Math.hypot(e.clientX - ultX, e.clientY - ultY) < 40) {
        ultToque = 0;
        alternar(e.clientX, e.clientY);
      } else { ultToque = agora; ultX = e.clientX; ultY = e.clientY; }
    }
    view.addEventListener('pointerup', soltar);
    view.addEventListener('pointercancel', soltar);
    view.addEventListener('dragstart', function (e) { e.preventDefault(); });
    view.addEventListener('wheel', function (e) {
      e.preventDefault();
      var roda = e.deltaMode === 1 || (Math.abs(e.deltaY) >= 50 && !e.deltaX);
      if (e.ctrlKey || roda || s <= 1.01) {
        var f = Math.exp(-e.deltaY * (e.ctrlKey ? 0.012 : 0.003));
        zoomEm(s * f, e.clientX, e.clientY, false);
      } else {
        tx -= e.deltaX; ty -= e.deltaY; limitar(); aplicar(false);
      }
    }, { passive: false });

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); fechar(); }
      else if (e.key === 'ArrowRight' && s <= 1.01 && itens.length > 1) { e.preventDefault(); mostrar(idx + 1); }
      else if (e.key === 'ArrowLeft' && s <= 1.01 && itens.length > 1) { e.preventDefault(); mostrar(idx - 1); }
      else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomEm(s * 1.5, null, null, true); }
      else if (e.key === '-') { e.preventDefault(); zoomEm(s / 1.5, null, null, true); }
      else if (e.key === 'Tab') {
        var focaveis = [bz, bx, bp, bn].filter(function (b) { return !b.hidden && b.offsetParent !== null; });
        var i = focaveis.indexOf(document.activeElement);
        e.preventDefault();
        var prox = focaveis[(i + (e.shiftKey ? -1 : 1) + focaveis.length) % focaveis.length];
        if (prox) prox.focus();
      }
    });
    var rt = 0;
    window.addEventListener('resize', function () {
      if (!aberto) return;
      clearTimeout(rt);
      rt = setTimeout(function () { medir(); limitar(); aplicar(false); }, 60);
    });

    LB = { abrir: abrir, fechar: fechar };
    return LB;
  }

  /* ---------------- Liga as fotos da galeria ---------------- */
  function preparar(g) {
    if (!g || g.__lfz) return;
    g.__lfz = true;
    var botoes = [];
    g.querySelectorAll('.lfp-slide--image').forEach(function (sl) {
      var im = sl.querySelector('img');
      if (!im) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lfp-zoombtn';
      b.setAttribute('aria-label', 'Ampliar foto');
      sl.insertBefore(b, im);
      b.appendChild(im);
      b.insertAdjacentHTML('beforeend', '<span class="lfp-zoombtn__ic" aria-hidden="true">' + IC.mais + '</span>');
      botoes.push(b);
    });
    botoes.forEach(function (b, k) {
      b.addEventListener('click', function () {
        var lista = botoes.map(function (z) {
          var im = z.querySelector('img');
          return {
            src: srcHD(im),
            low: im.complete && im.naturalWidth ? (im.currentSrc || im.src) : '',
            w: Number(im.getAttribute('width')) || im.naturalWidth || 0,
            h: Number(im.getAttribute('height')) || im.naturalHeight || 0,
            alt: im.getAttribute('alt') || ''
          };
        });
        visualizador().abrir(lista, k);
      });
    });
  }

  LFZoom.iniciar = function (root) {
    (root || document).querySelectorAll('[data-lfp-gallery]').forEach(preparar);
  };
  if (document.readyState !== 'loading') LFZoom.iniciar(document);
  else document.addEventListener('DOMContentLoaded', function () { LFZoom.iniciar(document); });
  document.addEventListener('shopify:section:load', function (e) { LFZoom.iniciar(e.target); });
})();
